<template lang="pug">
menu-item(label="External Tile Data")
  menu-item(label="Add...", @click="add")
  menu-separator
  menu-item(v-for="t in entries", :key="Id(t)", :label="t.baseUrl", v-model="t.showParamsWindow")
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { ExternalTileDataModule } from "./";
import { store } from '../../store';
import { defaultParams } from '../SspDataModule';
import axios from 'axios'

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: ExternalTileDataModule

  get entries() {
    return this.module.entries
  }

  async add() {
    let baseUrl = prompt('Base URL?')
    if (baseUrl) {
      await this.module.add({ baseUrl })
    }
  }
}
</script>
